export default "/assets/images/hhr-access-screenshot.2ebffa8594a858d6.jpeg";